(()=>{
  'use strict';
  const menu=document.querySelector('[data-mbf-mobile-menu]');
  if(!menu)return;
  const body=document.body;
  const panel=menu.querySelector('.mobile-menu__panel');
  const openers=[...document.querySelectorAll('[data-mbf-menu-open]')];
  const closers=[...menu.querySelectorAll('[data-mbf-menu-close]')];
  const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const closeDelay=reduceMotion?0:310;
  let lastTrigger=null;
  let closeTimer=null;

  if(menu.parentElement!==body) body.appendChild(menu);

  const otherOverlayOpen=()=>['[data-mbf-cart-drawer]','[data-mbf-ai-modal]','[data-mbf-entry]'].some(selector=>{
    const el=document.querySelector(selector);
    return Boolean(el && !el.hidden);
  });

  const focusables=()=>panel?[...panel.querySelectorAll('a[href],button:not([disabled]),select:not([disabled]),input:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(el=>!el.hidden&&el.getAttribute('aria-hidden')!=='true'):[];

  const syncBodyLock=open=>{
    body.classList.toggle('mbf-menu-open',open);
    body.classList.toggle('is-locked',open||otherOverlayOpen());
  };

  const syncAria=open=>{
    menu.setAttribute('aria-hidden',open?'false':'true');
    openers.forEach(button=>button.setAttribute('aria-expanded',open?'true':'false'));
  };

  const openMenu=trigger=>{
    if(closeTimer){clearTimeout(closeTimer);closeTimer=null;}
    if(trigger)lastTrigger=trigger;
    menu.hidden=false;
    syncAria(true);
    syncBodyLock(true);
    requestAnimationFrame(()=>requestAnimationFrame(()=>{
      menu.classList.add('is-open');
      const target=menu.querySelector('[data-mbf-menu-close]')||panel;
      if(target&&typeof target.focus==='function')target.focus({preventScroll:true});
    }));
  };

  const closeMenu=(restoreFocus=true)=>{
    menu.classList.remove('is-open');
    syncAria(false);
    syncBodyLock(false);
    if(closeTimer)clearTimeout(closeTimer);
    closeTimer=setTimeout(()=>{
      if(!menu.classList.contains('is-open'))menu.hidden=true;
      closeTimer=null;
      if(restoreFocus&&lastTrigger&&typeof lastTrigger.focus==='function')lastTrigger.focus({preventScroll:true});
    },closeDelay);
  };

  openers.forEach(button=>button.addEventListener('click',event=>{
    event.preventDefault();
    event.stopImmediatePropagation();
    openMenu(button);
  },true));

  closers.forEach(button=>button.addEventListener('click',event=>{
    event.preventDefault();
    event.stopImmediatePropagation();
    closeMenu(true);
  },true));

  menu.addEventListener('click',event=>{
    if(event.target===menu){event.preventDefault();event.stopImmediatePropagation();closeMenu(true);}
  },true);

  document.addEventListener('keydown',event=>{
    if(menu.hidden||!menu.classList.contains('is-open'))return;
    if(event.key==='Escape'){
      event.preventDefault();event.stopImmediatePropagation();closeMenu(true);return;
    }
    if(event.key!=='Tab')return;
    const items=focusables();
    if(!items.length){event.preventDefault();panel?.focus();return;}
    const first=items[0],last=items[items.length-1];
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  },true);

  window.addEventListener('resize',()=>{
    if(window.innerWidth>900&&!menu.hidden)closeMenu(false);
  },{passive:true});

  menu.classList.remove('is-open');
  menu.hidden=true;
  syncAria(false);
  syncBodyLock(false);
})();
